











import {ChartDataTemplate, FCConfTpl, WConfTpl, WidgetDefinition, WParamTpl} from "@/components/widgets/WidgetFather"
import {defineComponent, reactive} from "@vue/composition-api"
import {getLocationCaption} from "@/data/sources/appraisal"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"
import {executeQuery} from "@/data/repos/query";

export function config(): WidgetDefinition {
  return {
    ...WConfTpl.Custom(),
    widget: 'RoomDataAgeProfile',
    title: 'Room Data Age Profile',
    cType: "scrollstackedcolumn2d",
    params: {
      locationId: {...WParamTpl.locationId(), _order: 1},
    },
  }
}

function getChartConfig() {
  return reactive(FCConfTpl())
}

function chartDSTemplate() { // required if FC data not in {data: {}} format
  return {
    categories: [],
    dataset: [],
  }
}

function getChartDataConfig() {
  return reactive({
        ...ChartDataTemplate(),
        caption: 'Room Data Age Profile',
        theme: 'micad',
        // legendCaptionFontSize: "9",
        showLabels: "1",
        // rotateLabels: "1",
        slantLabels: "1",
        // valueFontColor: "#EEE",
        xAxisName: "Buildings",
      },
  )
}

async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
  if (config) {
    chartDataConfig.subCaption = "Location: " + await getLocationCaption(config.params.locationId)
  }
}

export default defineComponent({
  props: {
    config: Object,
  },
  components: {
    FusionChartWidget,
  },
  setup(props, context) {
    context.emit('config-update', config())
    return {dataFetcher, getChartDataConfig, configChangeCallback, chartDSTemplate}
  },
})

async function dataFetcher(params: any): Promise<any> {
  const data = await executeQuery("idr", "roomDataAgeProfile", {
    locationId: parseInt(params.locationId.value) || 10
  })
  // {"BuildingId":14922790,"BuildingName":"Health Centre","Year":2013,"BuildingArea":554.950}
  // {"BuildingId":14922790,"BuildingName":"Health Centre","Year":2017,"BuildingArea":123.450}
  // {"BuildingId":15711880,"BuildingName":"Asbestos Spreadsheet Import Building","Year":2021,"BuildingArea":0.000}
  console.info("RoomDataAgeProfile:", data)
  const buildings: {id: number, name: string}[] = []
  const buildingSpace: Map<number, number[]> = new Map<number, number[]>()
  const currentYear: number = new Date().getFullYear()
  data.forEach(item => {
    const building = {id: item.BuildingId, name: item.BuildingName};
    if (!buildingSpace.has(building.id)) {
      buildings.push(building)
    }
    const areas = buildingSpace.get(building.id) || [0, 0, 0]
    if (item.Year >= currentYear - 1)
      areas[0] += item.BuildingArea
    else if (item.Year >= currentYear - 3)
      areas[1] += item.BuildingArea
    else
      areas[2] += item.BuildingArea
    buildingSpace.set(building.id, areas)
  })
  console.info("buildings:", buildings)
  console.info("buildingSpace:", buildingSpace)
  return {
    categories: [ // buildings
      {
        category: buildings.map(item => {
          return {
            label: item.name,
          }
        })
      }
    ],
    dataset: [
      {
        seriesName: "0-1 yr old",
        color: "#6BAA01",
        data: buildings.map(item => {
          const area = buildingSpace.has(item.id) ? (buildingSpace.get(item.id) as number[])[0] : 0;
          return {
            value: area !== 0 ? "" + area : ""
          }
        })
      },
      {
        seriesName: "2-3 yr old",
        color: "#FFBF00",
        data: buildings.map(item => {
          const area = buildingSpace.has(item.id) ? (buildingSpace.get(item.id) as number[])[1] : 0;
          return {
            value: area !== 0 ? "" + area : ""
          }
        })
      },
      {
        seriesName: "4+ yr old",
        color: "#DC143C",
        data: buildings.map(item => {
          const area = buildingSpace.has(item.id) ? (buildingSpace.get(item.id) as number[])[2] : 0;
          return {
            value: area !== 0 ? "" + area : ""
          }
        })

      },
    ]
  }
}

